import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { BaseService } from "./base.service";

@Injectable()

export class ClientEventViewService extends BaseService {
  constructor(
    protected http: HttpClient
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/client_event_view`);
  }
}